import Pathes from '@/helpers/pathes';
import axios from '../../axios-api';

export const referralService = {
  validate: code => axios.get(Pathes.Referrals.checkRefCodeValidity(code)),
  apply: code => axios.post(Pathes.Referrals.applyRefCode, { code }),
};
